var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee-share-calc" },
    [
      _c("div", { staticClass: "head" }, [
        _c(
          "div",
          { staticClass: "row first" },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.shareName) + "总额：\n            "
            ),
            _c("el-input", {
              staticStyle: { width: "80px" },
              attrs: { size: "small", type: "number" },
              on: {
                change: function($event) {
                  _vm.syncShareAmount()
                }
              },
              model: {
                value: _vm.curShareAmount,
                callback: function($$v) {
                  _vm.curShareAmount = $$v
                },
                expression: "curShareAmount"
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.diffErrMsg,
                    expression: "diffErrMsg"
                  }
                ],
                staticStyle: { "margin-left": "20px" }
              },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: { effect: "dark", placement: "top" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { "line-height": "30px" },
                        attrs: { slot: "content" },
                        slot: "content"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.diffErrMsg) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { color: "#F56C6C", cursor: "default" } },
                      [
                        _c("i", {
                          staticClass: "el-icon-info",
                          staticStyle: { color: "red" }
                        }),
                        _vm._v("误差说明")
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { float: "right" } },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.syncForAspect },
                    model: {
                      value: _vm.curAspect,
                      callback: function($$v) {
                        _vm.curAspect = $$v
                      },
                      expression: "curAspect"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: "calc" } }, [
                      _vm._v("分摊计算")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: {
                          label: "balns",
                          title: "双击分摊明细行 可以 选定 误差承担条目"
                        }
                      },
                      [_vm._v("误差平衡")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: {
                          label: "both",
                          title: "双击分摊明细行 可以 选定 误差承担条目"
                        }
                      },
                      [_vm._v("分摊计算+误差平衡")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row second" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isCalcMode(),
                  expression: "isCalcMode()"
                }
              ],
              staticStyle: { color: "#AAAAAA" }
            },
            [
              _c("span", { staticStyle: { color: "#ff8000" } }, [
                _vm._v("依据 数量 x 参考单价 得出分摊权重，也可")
              ]),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "font-size": "12px" },
                  attrs: { size: "mini" },
                  model: {
                    value: _vm.inputWeight,
                    callback: function($$v) {
                      _vm.inputWeight = $$v
                    },
                    expression: "inputWeight"
                  }
                },
                [_vm._v("直接输入分摊权重")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "32px" },
                  attrs: {
                    title:
                      "从当前 分摊单价*数量 汇总分摊小计和分摊合计，并替换分摊费用总额"
                  },
                  on: { click: _vm.doSumFeeAmount }
                },
                [_vm._v("分摊反向汇总")]
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { direction: "vertical" } }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "swb-btn swb-btn-outlined",
                  staticStyle: { "margin-left": "32px" },
                  on: {
                    click: function($event) {
                      _vm.execCalcItems()
                    }
                  }
                },
                [_vm._v("分摊计算/误差平衡")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "listForm",
          staticClass: "list",
          attrs: { model: _vm.listForm }
        },
        [
          _c(
            "el-table",
            {
              staticClass: "simple-tbl",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.listForm.shareItems,
                "row-class-name": _vm.getRowClassName
              },
              on: { "row-dblclick": _vm.handleRowDblClick }
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "序号", width: "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.$index + 1) +
                            "\n                "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.ukIdTitle,
                  width: _vm.ukIdWidth
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.ukId) +
                            "\n                "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "left", label: _vm.nameTitle },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "shareItems[" + scope.$index + "].name"
                            }
                          },
                          [
                            _vm.useForUpdate
                              ? _c("span", [_vm._v(_vm._s(scope.row.name))])
                              : _c("el-input", {
                                  attrs: { size: "mini" },
                                  model: {
                                    value: scope.row.name,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name"
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "right", label: "数量", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "shareItems[" + scope.$index + "].quantity"
                            }
                          },
                          [
                            _vm.useForUpdate
                              ? _c("span", [_vm._v(_vm._s(scope.row.quantity))])
                              : _c("el-input", {
                                  staticClass: "number",
                                  attrs: { type: "number", size: "mini" },
                                  on: {
                                    change: function($event) {
                                      _vm.syncItemWeight(
                                        scope.$index,
                                        "quantity"
                                      )
                                    }
                                  },
                                  model: {
                                    value: scope.row.quantity,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "quantity", $$v)
                                    },
                                    expression: "scope.row.quantity"
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.isCalcMode() && !_vm.inputWeight
                ? _c("el-table-column", {
                    attrs: { align: "right", label: "参考货价", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  "margin-bottom": "0",
                                  color: "#ADADAD"
                                },
                                attrs: {
                                  prop:
                                    "shareItems[" + scope.$index + "].refPrice"
                                }
                              },
                              [
                                _vm.useForUpdate
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDecNum(scope.row.refPrice)
                                        )
                                      )
                                    ])
                                  : _c("el-input", {
                                      staticClass: "number",
                                      attrs: { type: "number", size: "mini" },
                                      on: {
                                        change: function($event) {
                                          _vm.syncItemWeight(
                                            scope.$index,
                                            "refPrice"
                                          )
                                        }
                                      },
                                      model: {
                                        value: scope.row.refPrice,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "refPrice", $$v)
                                        },
                                        expression: "scope.row.refPrice"
                                      }
                                    })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isCalcMode()
                ? _c("el-table-column", {
                    attrs: { align: "right", label: "分摊权重", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "shareItems[" + scope.$index + "].weight"
                                }
                              },
                              [
                                _vm.inputWeight
                                  ? _c("el-input", {
                                      staticClass: "number",
                                      attrs: { type: "number", size: "mini" },
                                      model: {
                                        value: scope.row.weight,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "weight", $$v)
                                        },
                                        expression: "scope.row.weight"
                                      }
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDecNum(scope.row.weight)
                                        )
                                      )
                                    ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "right", label: "分摊-单价", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.splitted
                          ? _c("i", {
                              staticClass: "el-icon-info",
                              staticStyle: {
                                float: "left",
                                "margin-top": "4px",
                                color: "orangered"
                              },
                              attrs: { title: "分摊-单价 有差异 (点击查看) " },
                              on: {
                                click: function($event) {
                                  _vm.showDiffPriceInfo(scope.$index)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatDecNum(scope.row.price)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "right", label: "分摊-小计", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "shareItems[" + scope.$index + "].amount"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "number",
                              attrs: { type: "number", size: "mini" },
                              model: {
                                value: scope.row.amount,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "amount", $$v)
                                },
                                expression: "scope.row.amount"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", width: "64" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(scope) {
                      return [
                        !_vm.useForUpdate
                          ? _c(
                              "el-link",
                              {
                                staticClass: "el-icon-plus",
                                staticStyle: { color: "darkblue" },
                                on: {
                                  click: function($event) {
                                    _vm.addShareItem()
                                  }
                                }
                              },
                              [_vm._v("追加")]
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("i", {
                          staticClass: "el-icon-close",
                          staticStyle: { color: "#bb4600", cursor: "pointer" },
                          attrs: { title: "移除此条目" },
                          on: {
                            click: function($event) {
                              _vm.delShareItem(scope.$index)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d14564b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d14564b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/FeeShareCalc.vue
// module id = 2225
// module chunks = 0